// extracted by mini-css-extract-plugin
export var ratingRowPosition = "rating-row-position__Fhm0";